import type { TaskDetails } from '@/task-manager/entities/task-details';

import { TaskUpdateTitle } from './task-update-title';

export type TaskUpdateSubtitleProps = {
  task: TaskDetails;
  onChange: (subtitle?: string) => Promise<void>;
};

export function TaskUpdateSubtitle({
  task,
  onChange,
}: TaskUpdateSubtitleProps) {
  if (task.alert?.suggestedAction) {
    return (
      <div className="w-full px-3 py-2 text-sm text-neutral-700">
        {task.alert.suggestedAction}
        {task.alert.resolved && (
          <span className="ml-2 rounded-md bg-green-50 px-2 py-1 text-xs font-medium text-green-800">
            Resolved - Move card to 'Done' column
          </span>
        )}
      </div>
    );
  }

  return (
    <TaskUpdateTitle
      title={task.subtitle}
      placeholder="Write a subtitle"
      onChange={onChange}
      className="text-sm"
    />
  );
}
